import React, { useState, useEffect, useRef } from "react";
import styles from "./EditBusinessDetail.module.css";
import EditHeader from "../EditHeader/EditHeader";
import SectionHeader from "../SectionHeader/SectionHeader";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import { useAgentCreator } from "../../hooks/useAgentCreator";
import decodeToken from "../../lib/decodeToken";
import { useLocation, useNavigate } from "react-router-dom";
import PopUp from "../Popup/Popup";
import axios from "axios";
import getKnowledgeBaseName from "../../utils/getKnowledgeBaseName";
import {
  API_BASE_URL,
  createKnowledgeBaseWithDetails,
  deleteKnowledgeBase,
  getAgentFiles,
  listSiteMap,
  validateWebsite,
} from "../../Store/apiStore";
import { useDashboardStore } from "../../Store/agentZustandStore";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import filterCompanyPages from "../../utils/companyKeyboards";
import Modal2 from "../Modal2/Modal2";
import GoogleAddressInputWithDropdown from "../GoogleAddressInputWithDropdown/GoogleAddressInputWithDropdown";

const safeJSONParse = (val, fallback) => {
  try {
    if (!val) return fallback;
    if (typeof val === "string" && val.includes("[object Object]"))
      return fallback;
    return JSON.parse(val);
  } catch {
    return fallback;
  }
};

const DEFAULT_HOURS_FALLBACK = [
  "Monday: 9:00 AM – 6:00 PM",
  "Tuesday: 9:00 AM – 6:00 PM",
  "Wednesday: 9:00 AM – 6:00 PM",
  "Thursday: 9:00 AM – 6:00 PM",
  "Friday: 9:00 AM – 6:00 PM",
  "Saturday: 9:00 AM – 6:00 PM",
  "Sunday: Closed",
];

const getDefaultHoursString = () => DEFAULT_HOURS_FALLBACK.join(" | ");

const hasValidGmbHours = (hours) => {
  if (!hours) return false;
  if (Array.isArray(hours)) return hours.filter(Boolean).length > 0;
  if (typeof hours === "string") return hours.trim().length > 0;
  return false;
};


const EditBusinessDetail = () => {
  const agentnm = sessionStorage.getItem("agentName");
  const [businessName, setBusinessName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [aboutBussiness, setAboutBusiness] = useState("");
  const [loading, setLoading] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("us");
  const [street_number, setStreet_number] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [postal_code, setPostal_code] = useState("");
  const [country_code, setCountry_code] = useState("");
  const [state_code, setState_code] = useState("");
  const token = localStorage.getItem("token");
  const decodeTokenData = decodeToken(token);
  const userId = decodeTokenData?.id;
  const navigate = useNavigate();
  const EditingMode1 = localStorage.getItem("UpdationMode");
  const { setHasFetched } = useDashboardStore();
  const agentCode = sessionStorage.getItem("agentCode") || "";
  const [originalData, setOriginalData] = useState({});
  const [isDirty, setIsDirty] = useState(false);
  const location = useLocation();
  const { isChanged } = location.state || {};
  const [siteMapModalOpen, setSiteMapModalOpen] = useState(false);
  const [siteMapList, setSiteMapList] = useState([]);
  const [hasValidatedWebsite, setHasValidatedWebsite] = useState(false);
  const [hasFetchedSitemap, setHasFetchedSitemap] = useState(false);
  const listRef = useRef(null);
  const isIphone = /iPhone|iPod/i.test(navigator.userAgent);
  const isAndroidApp = () =>
    /Android/i.test(navigator.userAgent) && window.ReactNativeWebView;
  const isIOSApp = () =>
    /iPhone|iPad|iPod/i.test(navigator.userAgent) && window.webkit;

  // ===== WEBSITE + SITEMAP STATES (same as BusinessListing) =====
  const [website, setWebsite] = useState("");
  const [hasNoWebsite, setHasNoWebsite] = useState(false);
  const [isValidWebsite, setIsValidWebsite] = useState(null); // true | false | null
  const [validateLoading, setValidateLoading] = useState(false);
  const typingTimer = useRef(null);
  const [filteredPages, setFilteredPages] = useState([]);
  const [manualUrlChanged, setManualUrlChanged] = useState(false);
  const [storedSelected, setStoredSelected] = useState(() => {
    return (
      safeJSONParse(
        sessionStorage.getItem("refreshSelectedSiteMapUrls"),
        null
      ) || safeJSONParse(sessionStorage.getItem("selectedSiteMapUrls"), [])
    );
  });

  const buildSiteMapList = (urls = [], scraped = []) => {
    const scrapedMap = new Map();

    if (Array.isArray(scraped)) {
      scraped.forEach((item) => {
        if (typeof item === "string") {
          scrapedMap.set(item, true);
        } else if (item?.url) {
          scrapedMap.set(item.url, !!item.checkedStatus);
        }
      });
    }
    return (urls || []).map((url) => ({
      url,
      checkedStatus: scrapedMap.get(url) === true,
    }));
  };

  const [checkedCount, setCheckedCount] = useState(0);
  const [fetchUrlDisable, setFetchUrlDisable] = useState(false);

  useEffect(() => {
    const rawScraped = sessionStorage.getItem("scrapedUrls");
    const scraped = safeJSONParse(rawScraped, null);
    if (!Array.isArray(scraped)) {
      const urls = safeJSONParse(sessionStorage.getItem("urls"), []);
      const rebuilt = (urls || []).map((url, index) => ({
        url,
        checkedStatus: index < 10,
      }));

      sessionStorage.setItem("scrapedUrls", JSON.stringify(rebuilt));
      sessionStorage.setItem(
        "refreshSelectedSiteMapUrls",
        JSON.stringify(rebuilt)
      );
      sessionStorage.setItem("selectedSiteMapUrls", JSON.stringify(rebuilt));

      setCheckedCount(rebuilt.filter((i) => i.checkedStatus).length);
      setFilteredPages(filterCompanyPages(urls));
      return;
    }
    setCheckedCount(scraped.filter((i) => i?.checkedStatus).length);

    const urls = safeJSONParse(sessionStorage.getItem("urls"), []);
    setFilteredPages(filterCompanyPages(urls));
  }, []);

  const removeEmojis = (str = "") =>
    str.replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/g,
      ""
    );
  const sanitizeDescription = (str = "") => {
    let v = str;

    v = removeEmojis(v);
    v = v.replace(/[^a-zA-Z0-9 .,?' -]/g, "");
    v = v.replace(/\s+/g, " ");
    v = v.trimStart();

    return v;
  };

  const { handleCreateAgent } = useAgentCreator({
    stepValidator: () => "EditBusinessDetail",
    setLoading,
    setPopupMessage,
    setPopupType,
    setShowPopup,
    navigate,
    setHasFetched,
  });
  const aboutBusinessForm = JSON.parse(
    sessionStorage.getItem("aboutBusinessForm") || "{}"
  );
  useEffect(() => {
    if (isChanged) {
      setIsDirty(isChanged);
    }
  }, [isChanged]);

  useEffect(() => {
    const storedDetails = sessionStorage.getItem("placeDetailsExtract");
    if (storedDetails) {
      const details = JSON.parse(storedDetails);
      setBusinessName(details?.businessName || "");
      setPhoneNumber(details.internationalPhone || details?.phone || "");
      setAddress(details?.address || "");
      setEmail(details?.email || "");
      setAboutBusiness(details?.aboutBusiness || details?.aboutBussiness || "");

      setOriginalData({
        businessName: details?.businessName || "",
        phoneNumber: details.internationalPhone || details?.phone || "",
        address: details?.address || "",
        email: details?.email || "",
        aboutBussiness: details?.aboutBusiness || details?.aboutBussiness || "",
        street_number: details?.street_number || "",
        city: details?.city || "",
        state: details?.state || "",
        postal_code: details?.postal_code || "",
        country: details?.country || "",
      });
    }
    if (EditingMode1 !== "ON" && storedDetails) {
      const details = JSON.parse(storedDetails);
      setAboutBusiness(details?.aboutBusiness || details?.aboutBussiness || "");
    }
  }, [EditingMode1]);

  // ===== WEBSITE INITIALIZATION (same behaviour as BusinessListing) =====
  const normalizeAndValidateUrl = (url) => {
    if (!url) return "";

    let u = url.trim();
    u = u.replace(/^(https?:\/\/)+/i, "https://");
    return u;
  };

  useEffect(() => {
    if (aboutBusinessForm?.noBusinessWebsite) {
      setHasNoWebsite(true);
      return;
    }

    if (aboutBusinessForm?.businessUrl) {
      const url = normalizeAndValidateUrl(aboutBusinessForm.businessUrl);
      setWebsite(url);

      // 🔹 Agar pehle step me sitemap already fetch ho chuka hai:
      const existingUrls = JSON.parse(sessionStorage.getItem("urls") || "[]");
      if (existingUrls.length > 0) {
        setIsValidWebsite(true);
        setHasValidatedWebsite(true);
        setHasFetchedSitemap(true);
      }
    } else {
      setWebsite("");
      setHasNoWebsite(true);
    }
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      const storedSelectedFromSession = JSON.parse(
        sessionStorage.getItem("refreshSelectedSiteMapUrls") || "[]"
      );
      const urls = JSON.parse(sessionStorage.getItem("urls") || "[]");
      const pages = filterCompanyPages(urls);
      setFilteredPages(pages);
      setStoredSelected(storedSelectedFromSession);

      if (storedSelectedFromSession.length > 0 && urls.length > 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const handleInputChange = (field, value) => {
    const currentData = JSON.parse(
      sessionStorage.getItem("placeDetailsExtract") || "{}"
    );
    const updatedData = { ...currentData, [field]: value };
    sessionStorage.setItem("placeDetailsExtract", JSON.stringify(updatedData));

    switch (field) {
      case "businessName":
        setBusinessName(value);
        break;
      case "phone":
      case "internationalPhone":
        setPhoneNumber(value);
        break;
      case "address":
        setAddress(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "aboutBussiness":
        setAboutBusiness(value);
        break;
      default:
        break;
    }

    const isChanged =
      (field === "businessName" && value !== originalData.businessName) ||
      (field === "phone" && value !== originalData.phoneNumber) ||
      (field === "internationalPhone" && value !== originalData.phoneNumber) ||
      (field === "address" && value !== originalData.address) ||
      (field === "email" && value !== originalData.email) ||
      (field === "aboutBussiness" && value !== originalData.aboutBussiness);

    setIsDirty(isChanged);
  };

  const formatLabel = (str) =>
    str
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (s) => s.toUpperCase())
      .replace(/_/g, " ");
  const handleWebsiteChange = (e) => {
    let input = e.target.value || "";
    if (!input.includes("https://")) {
      input = "https://";
    }
    let domainPart = input.replace(/^https:\/\//i, "");
    if (domainPart === "" && input === "https://") {
      domainPart = "";
    }
    const fullUrl = domainPart ? `https://${domainPart}` : "https://";
    setWebsite(fullUrl);
    setManualUrlChanged(true);

    // GET LAST USED DOMAIN FROM SESSION
    const lastDomain = sessionStorage.getItem("lastSitemapDomain");
    // URL changed? → CLEAR ALL SITEMAP DATA
    if (lastDomain && lastDomain !== fullUrl) {
      sessionStorage.removeItem("urls");
      sessionStorage.removeItem("scrapedUrls");
      sessionStorage.removeItem("selectedSiteMapUrls");
      sessionStorage.removeItem("refreshSelectedSiteMapUrls");

      setFilteredPages([]);
      setStoredSelected([]);
    }

    // SAVE THE LATEST DOMAIN ALWAYS
    sessionStorage.setItem("lastSitemapDomain", fullUrl);

    // RESET FLAGS
    setIsValidWebsite(null);
    setHasValidatedWebsite(false);
    setHasFetchedSitemap(false);

    // UPDATE aboutBusinessForm SESSION
    let aboutForm =
      JSON.parse(sessionStorage.getItem("aboutBusinessForm")) || {};

    aboutForm.businessUrl = fullUrl;

    sessionStorage.setItem("aboutBusinessForm", JSON.stringify(aboutForm));
    sessionStorage.setItem("businessUrl", fullUrl);

    // Don't validate if invalid domain
    if (input.length < 5 || !input.includes(".")) return;

    // Debounce validation
    if (typingTimer.current) clearTimeout(typingTimer.current);

    typingTimer.current = setTimeout(async () => {
      setValidateLoading(true);

      try {
        const result = await validateWebsite(fullUrl);
        const valid = !!result?.valid;
        setIsValidWebsite(valid);
        setHasValidatedWebsite(valid);
        if (valid) {
          // Normalize URL if backend returned corrected version
          if (result.finalUrl && result.finalUrl !== fullUrl) {
            let normalized = result.finalUrl.replace(/^https?:\/\//, "");
            normalized = "https://" + normalized;

            setWebsite(normalized);

            aboutForm =
              JSON.parse(sessionStorage.getItem("aboutBusinessForm")) || {};
            aboutForm.businessUrl = normalized;

            sessionStorage.setItem(
              "aboutBusinessForm",
              JSON.stringify(aboutForm)
            );
            sessionStorage.setItem("businessUrl", normalized);

            // Update tracking domain also
            sessionStorage.setItem("lastSitemapDomain", normalized);
          }
          // Fetch sitemap URLs
          const res = await listSiteMap(fullUrl);
          const urls = res.urls || [];

          if (!urls.includes(fullUrl)) urls.unshift(fullUrl);
          // --- FIX: Reset sitemap selection for NEW website ---
          sessionStorage.removeItem("scrapedUrls");
          sessionStorage.removeItem("selectedSiteMapUrls");

          // Always select ONLY first 10 items for a new sitemap
          const initialList = urls.map((url, index) => ({
            url,
            checkedStatus: index < 10,
          }));

          sessionStorage.setItem("scrapedUrls", JSON.stringify(initialList));
          sessionStorage.setItem(
            "refreshSelectedSiteMapUrls",
            JSON.stringify(initialList)
          );
          sessionStorage.setItem(
            "selectedSiteMapUrls",
            JSON.stringify(initialList)
          );
          sessionStorage.setItem("urls", JSON.stringify(urls));

          setCheckedCount(initialList.filter((i) => i.checkedStatus).length);
          window.dispatchEvent(new Event("sitemapSelectionUpdated"));

          // Sitemap fetched flag
          if (urls.length > 0) {
            setHasFetchedSitemap(true);
          }
        } else {
          setHasFetchedSitemap(false);
        }
      } catch (err) {
        console.error("URL Validation Error:", err);
        setIsValidWebsite(false);
        setHasValidatedWebsite(false);
        setHasFetchedSitemap(false);
      } finally {
        setValidateLoading(false);
      }
    }, 800);
  };

  const handleWebsiteCheckbox = (e) => {
    const checked = e.target.checked;
    setHasNoWebsite(checked);

    // let data = JSON.parse(sessionStorage.getItem("aboutBusinessForm")) || {};

    // if (checked) {
    //   delete data.businessUrl;
    //   data.noBusinessWebsite = true;
    //   setWebsite("");

    //   // If no website → clear sitemap data
    //   sessionStorage.removeItem("urls");
    //   sessionStorage.removeItem("scrapedUrls");
    //   sessionStorage.removeItem("selectedSiteMapUrls");
    //   sessionStorage.removeItem("refreshSelectedSiteMapUrls");
    //   sessionStorage.removeItem("lastSitemapDomain");
    // } else {
    //   delete data.noBusinessWebsite;
    // }

    // sessionStorage.setItem("aboutBusinessForm", JSON.stringify(data));
  };
  const handleOpenSiteMap = () => {
    const urls = safeJSONParse(sessionStorage.getItem("urls"), []);
    const scraped = safeJSONParse(sessionStorage.getItem("scrapedUrls"), []);

    const list = buildSiteMapList(urls, scraped);
    sessionStorage.setItem("scrapedUrls", JSON.stringify(list));
    sessionStorage.setItem("refreshSelectedSiteMapUrls", JSON.stringify(list));
    sessionStorage.setItem("selectedSiteMapUrls", JSON.stringify(list));

    setSiteMapList(list);
    setCheckedCount(list.filter((i) => i.checkedStatus).length);
    setSiteMapModalOpen(true);
  };

  const MAX_SELECTED_URLS = 100;
  const toggleSiteMapItem = (url) => {
    const currentItem = siteMapList.find((i) => i.url === url);
    if (!currentItem) return;

    const willSelect = !currentItem.checkedStatus;

    // current selected count
    const currentSelectedCount = siteMapList.filter(
      (i) => i.checkedStatus
    ).length;

    if (willSelect && currentSelectedCount >= MAX_SELECTED_URLS) {
      setPopupType("failed");
      setPopupMessage(`You can select upto ${MAX_SELECTED_URLS} urls.`);
      setShowPopup(true);
      return;
    }

    const updated = siteMapList.map((item) =>
      item.url === url ? { ...item, checkedStatus: !item.checkedStatus } : item
    );

    setSiteMapList(updated);

    // ✅ ALWAYS store object list (single source of truth)
    sessionStorage.setItem("scrapedUrls", JSON.stringify(updated));
    sessionStorage.setItem(
      "refreshSelectedSiteMapUrls",
      JSON.stringify(updated)
    );
    sessionStorage.setItem("selectedSiteMapUrls", JSON.stringify(updated));

    // ✅ correct count
    setCheckedCount(updated.filter((i) => i.checkedStatus).length);

    // optional UI sync
    window.dispatchEvent(new Event("sitemapSelectionUpdated"));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
    if (validateLoading) {
      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage("Please wait while we validate your website URL.");
      return;
    }
    if (!website && !hasNoWebsite) {
      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage(
        "Please enter a valid website URL or select 'I do not have Business website'."
      );
      return;
    }

    if (emailError) {
      return;
    }
    try {
      setLoading(true);
      const aboutBusinessForm = JSON.parse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );
      let placeDetails = JSON.parse(
        sessionStorage.getItem("placeDetailsExtract") || "{}"
      );
      if (address && address !== originalData.address && !addressPickedRef.current) {
        const parts = await geocodeAddress(address);
        if (parts) placeDetails = { ...placeDetails, ...parts };
      }
      const finalHours = hasValidGmbHours(placeDetails?.hours)
  ? (Array.isArray(placeDetails.hours)
      ? placeDetails.hours.join(" | ")
      : String(placeDetails.hours))
  : getDefaultHoursString();

      const business = JSON.parse(
        sessionStorage.getItem("businessDetails") || "{}"
      );
      const sessionBusinessiD = JSON.parse(sessionStorage.getItem("bId"));
      const knowledgeBaseId = sessionStorage.getItem("knowledgeBaseId");
      const displayBusinessName = sessionStorage.getItem("displayBusinessName");
      const packageName = sessionStorage.getItem("package") || "Free";
      const stepEditingMode = localStorage.getItem("UpdationModeStepWise");
      const EditingMode = localStorage.getItem("UpdationMode");
      const googleListing = sessionStorage.getItem("googleListing");
      const sessionSelectedSiteMapUrls = JSON.parse(
        sessionStorage.getItem("scrapedUrls")
      );
      const agentCount = 0;

      if (!businessName || !address || !phoneNumber) {
        setShowPopup(true);
        setPopupType("failed");
        setPopupMessage("Please fill all required fields.");
        return;
      }

      const updatedPlaceDetails = {
  ...placeDetails,
  businessName: businessName || placeDetails?.businessName,
  phone: phoneNumber,
  address: address,
  email: email,
  aboutBussiness: aboutBussiness,
  hours: finalHours,
};

      sessionStorage.setItem(
        "placeDetailsExtract",
        JSON.stringify(updatedPlaceDetails)
      );

      const packageMap = {
        Free: 1,
        Starter: 2,
        Scaler: 3,
        Growth: 4,
        Corporate: 5,
        Enterprise: 6,
      };
      const packageValue = packageMap[packageName] || 1;
      const knowledgeBaseName = await getKnowledgeBaseName(
        business,
        userId,
        packageValue,
        agentCode
      );

      const businessData = {
        businessName: businessName || placeDetails?.businessName || "",
        address: placeDetails?.address || address,
        phone: placeDetails?.phone || phoneNumber,
        website: placeDetails?.website || aboutBusinessForm.businessUrl,
        rating: placeDetails?.rating || "",
        totalRatings: placeDetails?.totalRatings || "",
        hours: finalHours,
        businessStatus: placeDetails?.businessStatus || "",
        categories: Array.isArray(placeDetails?.categories)
          ? placeDetails.categories.join(", ")
          : "",
        email: email,
        aboutBussiness: aboutBussiness,
        street_number: placeDetails.street_number || "",
        city: placeDetails.city,
        state: placeDetails.state,
        country: placeDetails.country,
        postal_code: placeDetails.postal_code,
        state_code: placeDetails.state_code,
        country_code: placeDetails.country_code,
      };

      const placeDetailsForKBT = JSON.parse(
        sessionStorage.getItem("placeDetailsExtract") || "{}"
      );
      const readableDetails = Object?.entries(placeDetailsForKBT)
        .map(
          ([key, value]) =>
            `${formatLabel(key)}: ${
              Array.isArray(value) ? value.join(", ") : value || "N/A"
            }`
        )
        .join("\n");

      const knowledgeBaseText = [
        {
          title: "Business Details",
          text: readableDetails,
        },
      ];

      function extractAddressFields(addressComponents) {
        const getComponent = (primaryType, fallbackType = null) =>
          addressComponents.find(
            (comp) =>
              comp.types.includes(primaryType) ||
              (fallbackType && comp.types.includes(fallbackType))
          )?.long_name || "";

        return {
          city: getComponent("locality", "sublocality_level_1"),
          state: getComponent("administrative_area_level_1"),
          country: getComponent("country"),
          postal_code: getComponent("postal_code"),
          street_number: getComponent("street_number"),
          state_code: getComponent("administrative_area_level_1", null, true),
          country_code: getComponent("country", null, true),
        };
      }

      const addressFields = extractAddressFields(
        placeDetails?.address_components || []
      );
      setCity(addressFields.city);
      setState(addressFields.state);
      setCountry(addressFields.country);
      setPostal_code(addressFields.postal_code);
      setStreet_number(addressFields.street_number);
      setCountry_code(addressFields.country_code);
      setCountry_code(addressFields.state_code);
      setState_code(addressFields.street_number);

      const rawUrl = aboutBusinessForm.businessUrl?.trim();
      const mergedUrls = [];

      if (sessionSelectedSiteMapUrls?.length > 0) {
        mergedUrls.push(
          ...sessionSelectedSiteMapUrls
            ?.filter((item) => item.checkedStatus)
            ?.map((item) => item.url)
        );
      } else if (rawUrl) {
        mergedUrls.push(rawUrl);
      }

      if (googleListing) {
        mergedUrls.push(googleListing);
      }

      const formData = new FormData();
      const formData2 = new FormData();
      const formData3 = new FormData();
      let agentId = localStorage.getItem("agent_id");
      let knowledge_Base_ID = knowledgeBaseId;

      if (
        knowledge_Base_ID !== null &&
        knowledge_Base_ID !== undefined &&
        knowledge_Base_ID !== "null" &&
        knowledge_Base_ID !== "undefined" &&
        knowledge_Base_ID !== ""
      ) {
        try {
          await deleteKnowledgeBase(token, knowledge_Base_ID);
        } catch (error) {
          console.log("error while removing prev Knowledgbase", error);
        }
      }

      const filesResponse = await getAgentFiles(agentId);
      const existingFiles = filesResponse?.files || [];

      if (existingFiles.length > 0) {
        for (const file of existingFiles) {
          const byteCharacters = atob(file.data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const fileBlob = new Blob([byteArray], { type: file.mimetype });

          const fileObject = new File([fileBlob], file.name, {
            type: file.mimetype,
          });
          formData.append("knowledge_base_files", fileObject);
        }
      }

      if (mergedUrls.length > 0) {
        formData.append("knowledge_base_urls", JSON.stringify(mergedUrls));
        formData3.append("knowledge_base_urls", JSON.stringify(mergedUrls));
      }
      formData.append("knowledge_base_name", knowledgeBaseName);
      formData.append("enable_auto_refresh", "true");
      formData.append(
        "knowledge_base_texts",
        JSON.stringify(knowledgeBaseText)
      );
      formData2.append("knowledge_base_texts", JSON.stringify(businessData));

      formData2.append("googleUrl", aboutBusinessForm?.googleListing);
      formData2.append(
        "webUrl",
        hasNoWebsite ? "" : aboutBusinessForm?.businessUrl?.trim()
      );
      formData2.append("aboutBusiness", aboutBussiness);
      formData2.append("additionalInstruction", aboutBusinessForm?.note || "");
      formData2.append("agentId", localStorage.getItem("agent_id"));
      formData2.append("googleBusinessName", displayBusinessName || "");
      formData2.append("address1", businessData?.address);
      formData2.append("businessEmail", email);
      formData2.append(
        "scrapedUrls",
        JSON.stringify(sessionSelectedSiteMapUrls) || []
      );
      formData2.append(
        "businessName",
        placeDetails?.businessName || businessName
      );
      formData2.append("phoneNumber", phoneNumber);
      formData2.append("isGoogleListing", aboutBusinessForm?.noGoogleListing);
      formData2.append("isWebsiteUrl", aboutBusinessForm?.noBusinessWebsite);
      formData2.append("city", businessData?.city || city);
      formData2.append("state", businessData?.state || state);
      formData2.append("country", businessData?.country || country);
      formData2.append("postal_code", businessData?.postal_code || postal_code);
      formData2.append(
        "country_code",
        businessData?.country_code || country_code
      );
      formData2.append("state_code", businessData?.state_code || state_code);
      formData2.append(
        "street_number",
        businessData?.street_number || street_number
      );

      try {
        const response = await createKnowledgeBaseWithDetails(token, formData);

        if (response?.success === false) {
          throw new Error(response?.message || "KB create failed");
        }
        const kbId = response?.data?.knowledge_base_id;

        formData2.append("knowledge_base_id", kbId);
        formData2.append("knowledge_base_name", knowledgeBaseName);

        knowledge_Base_ID = kbId;
        sessionStorage.setItem("knowledgeBaseId", kbId);
      } catch (error) {
        console.log("error while creating knowledge base via backend", error);
      }

      await axios.patch(
        `${API_BASE_URL}/businessDetails/updateKnowledeBase/${sessionBusinessiD}`,
        formData2,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_RETELL_API}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (EditingMode === "ON" && knowledge_Base_ID) {
        handleCreateAgent();
        setHasFetched(false);
      }
    } catch (error) {
      if (error?.response?.status === 422) {
        setShowPopup(true);
        setPopupType("failed");
        setPopupMessage(
          "Knowledge base is currently updating. Try again later."
        );
      } else {
        setShowPopup(true);
        setPopupType("failed");
        console.error("Submission failed:", error);
        setPopupMessage("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  // Address field: typing updates the text; picking a suggestion also loads
  // its parts (city, state, zip...) like the old Google Autocomplete did.
  const handleAddressChange = (value, placeId) => {
    addressPickedRef.current = !!placeId;
    handleInputChange("address", value);
    if (!placeId || !window.google?.maps?.places) return;
    new window.google.maps.places.PlacesService(
      document.createElement("div")
    ).getDetails(
      {
        placeId,
        fields: ["address_components", "formatted_address", "geometry", "url"],
      },
      (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          applyPlace(place);
        }
      }
    );
  };

  // A typed address (no suggestion picked) never updated city, state, country
  // or zip, so a business moved India → US kept India's — and the timezone
  // looked up from it. Geocode the typed text into the same fields.
  const addressPickedRef = useRef(false);
  const geocodeAddress = async (text) => {
    if (!text || !window.google?.maps?.Geocoder) return null;
    try {
      const { results } = await new window.google.maps.Geocoder().geocode({
        address: text,
      });
      return results?.[0] ? extractAndStoreAddressComponents(results[0]) : null;
    } catch (e) {
      console.warn("Address lookup failed:", e?.message || e);
      return null;
    }
  };

  const applyPlace = (place) => {
      if (place?.formatted_address) {
        const extracted = extractAndStoreAddressComponents(place);
        setAddress(place.formatted_address);

        const changed =
          businessName !== originalData.businessName ||
          phoneNumber !== originalData.phoneNumber ||
          email !== originalData.email ||
          aboutBussiness !== originalData.aboutBussiness ||
          place.formatted_address !== originalData.address ||
          extracted.street_number !== originalData.street_number ||
          extracted.city !== originalData.city ||
          extracted.state !== originalData.state ||
          extracted.postal_code !== originalData.postal_code ||
          extracted.country !== originalData.country;

        setIsDirty(changed);
      }
  };

  const extractAndStoreAddressComponents = (place) => {
    if (!place || !place.address_components) {
      console.error("Invalid place object:", place);
      return {};
    }

    const components = place.address_components;
    const getComponent = (
      primaryType,
      fallbackType = null,
      useShort = false
    ) => {
      const comp = components.find(
        (c) =>
          c.types.includes(primaryType) ||
          (fallbackType && c.types.includes(fallbackType))
      );
      return comp ? (useShort ? comp.short_name : comp.long_name) : "";
    };

    const addressDetails = {
      street_number: getComponent("street_number"),
      route: getComponent("route"),
      city: getComponent("locality") || getComponent("sublocality_level_1"),
      state: getComponent("administrative_area_level_1"),
      country: getComponent("country"),
      postal_code: getComponent("postal_code"),
      country_code: getComponent("country", null, true),
      state_code: getComponent("administrative_area_level_1", null, true),
      full_address: place.formatted_address || "",
    };

    const currentDetails = JSON.parse(
      sessionStorage.getItem("placeDetailsExtract") || "{}"
    );

    const updatedDetails = {
      ...currentDetails,
      ...addressDetails,
      address_components: components,
    };

    sessionStorage.setItem(
      "placeDetailsExtract",
      JSON.stringify(updatedDetails)
    );
    return addressDetails;
  };
  const fetchSitemapUrl = async (fullUrl) => {
    try {
      setValidateLoading(true);
      setFetchUrlDisable(true);
      const res = await listSiteMap(fullUrl);
      const urls = res.urls || [];

      if (!urls.includes(fullUrl)) urls.unshift(fullUrl);

      sessionStorage.setItem("urls", JSON.stringify(urls));

      const pages = filterCompanyPages(urls);
      setFilteredPages(pages);
      setFetchUrlDisable(false);
      setValidateLoading(false);
      setIsValidWebsite(true);
    } catch (error) {}
  };
  const scrollListIntoView = () => {
    if (listRef.current) {
      listRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleFocus = (e) => {
    if (isAndroidApp() || isIOSApp()) {
      setTimeout(() => {
        e.target.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 300);
    }
  };
  useEffect(() => {
    if (aboutBusinessForm.businessUrl) {
      fetchSitemapUrl(aboutBusinessForm?.businessUrl);
    }
  }, []);
  useEffect(() => {
    const sync = () => {
      const stored = safeJSONParse(sessionStorage.getItem("scrapedUrls"), []);
      setCheckedCount((stored || []).filter((i) => i?.checkedStatus).length);
    };

    sync();

    window.addEventListener("sitemapSelectionUpdated", sync);
    return () => window.removeEventListener("sitemapSelectionUpdated", sync);
  }, [website, isValidWebsite, hasFetchedSitemap]);

  const canSave =
    isDirty &&
    !validateLoading &&
    (hasNoWebsite ||
      (hasValidatedWebsite && isValidWebsite === true && hasFetchedSitemap));

  useEffect(() => {
    const urls = safeJSONParse(sessionStorage.getItem("urls"), []);
    const stored = safeJSONParse(sessionStorage.getItem("scrapedUrls"), []);

    setFilteredPages(filterCompanyPages(urls));
    setCheckedCount((stored || []).filter((i) => i?.checkedStatus).length);
  }, []);

  return (
    <>
      <EditHeader title="Edit Agent " agentName={agentnm} />
      <div className={styles.Maindiv}>
        <SectionHeader
          heading="Business Details"
          subheading="Verify or Update your Business Details we got from your public listings"
          highlight=""
        />
      </div>

      <div className={styles.container}>
        {/* WEBSITE SECTION – same UX as BusinessListing */}
        <div className={styles.formGroupurl}>
          <label>Website (URL)</label>
          <div className={styles.inputWrapper}>
            <input
              type="text"
              placeholder="https://Designersx.us"
              value={hasNoWebsite ? "" : website}
              onChange={handleWebsiteChange}
              disabled={hasNoWebsite || validateLoading}
            />
            {website && !hasNoWebsite && (
              <>
                {validateLoading && (
                  <div className={`newloader ${styles.checkIcon}`}></div>
                )}

                {!validateLoading && isValidWebsite === true && (
                  <img
                    src="/svg/check-icon.svg"
                    alt="check"
                    className={styles.checkIcon}
                  />
                )}

                {!validateLoading && isValidWebsite === false && (
                  <img
                    src="/svg/cross-icon.svg"
                    alt="cross"
                    className={styles.checkIcon}
                  />
                )}
              </>
            )}
          </div>
        </div>
        <div
          className={styles.checkRowDiv}
          style={{
            pointerEvents: validateLoading ? "none" : "auto",
            opacity: validateLoading ? 0.6 : 1,
          }}
        >
          <div className={styles.checkboxRow}>
            <input
              type="checkbox"
              id="nowebsite"
              className={styles.checkbox}
              checked={hasNoWebsite}
              onChange={handleWebsiteCheckbox}
            />
            <label htmlFor="nowebsite" className={styles.newLabel}>
              I don't have a website
            </label>
          </div>

          {/* Always render, just hide visually when not applicable */}
          {isValidWebsite === true && !hasNoWebsite && (
            <div className={styles.p12} onClick={handleOpenSiteMap}>
              <p className={styles.p1}>{checkedCount} pages selected</p>
              <p className={styles.p2}>
                {filteredPages ? filteredPages?.length : ""} pages found
              </p>
            </div>
          )}
        </div>
        <div className={styles.inputSection}>
          <label className={styles.label} ref={listRef}>
            Business Name
          </label>

          <input
            type="text"
            className={styles.input}
            placeholder="Your Business Name"
            value={businessName}
            onChange={(e) => handleInputChange("businessName", e.target.value)}
            onFocus={(e) => {
              if (!isIphone) {
                handleFocus(e);
                setTimeout(scrollListIntoView, 300);
              }
            }}
            onClick={(e) => {
              if (!isIphone) {
                handleFocus(e);
                setTimeout(scrollListIntoView, 300);
              }
            }}
          />
        </div>

        <div className={styles.inputSection}>
          <label className={styles.label}>Phone Number</label>
          <PhoneInput
            country={selectedCountry}
            value={phoneNumber}
            onChange={(phone, countryData) => {
              const fullPhone = phone.startsWith("+") ? phone : `+${phone}`;
              setPhoneNumber(fullPhone);
              setSelectedCountry(countryData?.countryCode || "us");
              handleInputChange("phone", fullPhone);
            }}
            inputStyle={{
              width: "100%",
              height: "40px",
              paddingLeft: "45px",
              borderRadius: "5px",
            }}
            placeholder="+1 (123)456-7890"
          />
        </div>

        <div className={styles.inputSection}>
          <label className={styles.label}>Address</label>
          {/* Same field as onboarding: suggestions open inline below it
              (Google's floating list landed off-screen on phones), and the
              address wraps instead of being cut off. */}
          <GoogleAddressInputWithDropdown
            multiline
            inputClassName={`${styles.input} ${styles.addressInput}`}
            value={address}
            onChange={handleAddressChange}
            placeholder="Business Address"
            listPosition="relative"
            listPaddingRight="0px"
            listMarginTop="8px"
          />
        </div>

        <div className={styles.inputSection}>
          <label className={styles.label}>Business Email</label>
          <input
            type="email"
            className={styles.input}
            placeholder="Business Email Address"
            value={email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            onBlur={(e) => {
              const value = e.target.value;
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

              if (value && !emailRegex.test(value)) {
                setEmailError("Please enter a valid email address.");
              } else {
                setEmailError("");
              }
            }}
          />
          {emailError && <p style={{ color: "red" }}>{emailError}</p>}
        </div>

        <div className={styles.inputSection}>
          <label className={styles.label}>
            Business Intro for Your Agent to know
          </label>
          <textarea
            rows="3"
            cols="50"
            className={styles.textarea}
            placeholder="Write an Intro for your Business here"
            value={aboutBussiness}
            onChange={(e) => {
              const cleaned = sanitizeDescription(e.target.value);
              handleInputChange("aboutBussiness", cleaned);
            }}
            onBlur={() => {
              const finalText = (aboutBussiness || "")
                .replace(/\s+/g, " ")
                .trim();
              handleInputChange("aboutBussiness", finalText);
            }}
            onPaste={(e) => {
              e.preventDefault();
              const paste = e.clipboardData.getData("text");
              const cleaned = sanitizeDescription(paste);
              const finalVal = sanitizeDescription(
                (aboutBussiness || "") + " " + cleaned
              );
              handleInputChange("aboutBussiness", finalVal);
            }}
          ></textarea>
        </div>

        <div className={styles.stickyWrapper} onClick={handleSubmit}>
          <AnimatedButton
            label="Save"
            isLoading={loading}
            disabled={!canSave}
          />
        </div>

        {showPopup && (
          <PopUp
            type={popupType}
            onClose={() => {
              setShowPopup(false);
            }}
            message={popupMessage}
            onConfirm={() => {}}
          />
        )}

        {siteMapModalOpen && (
          <Modal2
            isOpen={siteMapModalOpen}
            onClose={() => setSiteMapModalOpen(false)}
            type="info"
          >
            <div className={styles.wrapper}>
              <h2 className={styles.title}>List of pages</h2>
              <h3 className={styles.subtitle}>From Your Website</h3>
              <div className={styles.rowWrapper}>
                {siteMapList.map((page, index) => (
                  <div className={styles.row} key={index}>
                    <p
                      className={styles.pageUrl}
                      title={page?.url}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSiteMapItem(page?.url);
                      }}
                    >
                      {page?.url?.length > 40
                        ? page?.url?.slice(0, 40) + "..."
                        : page?.url}
                    </p>

                    <input
                      type="checkbox"
                      className={styles.checkbox1}
                      checked={page.checkedStatus}
                      onChange={() => toggleSiteMapItem(page.url)}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div
              onClick={() => setSiteMapModalOpen(false)}
              className={styles.btnTheme}
            >
              <AnimatedButton label="Confirmed" positionType="relative" />
            </div>
          </Modal2>
        )}
      </div>
    </>
  );
};

export default EditBusinessDetail;
